import withHttp from '@/config/withHttp';
var baseURL = '/judgeagent';
/* *************** 庭审业务相关接口 ******************* */

var apis = {
  // 获取未排期案件
  unPlanCase: {
    url: '/case/unPlanCase',
    method: 'post'
  },
  // 获取今天未开庭排期
  todaySchedules: {
    url: '/schedule/todaySchedules',
    method: 'post'
  },
  // 获取月待庭审排期
  myScheduleWithDate: {
    url: '/schedule/myScheduleWithDate',
    method: 'post'
  },
  // 获取月我创建的排期
  myCreateScheduleWithDate: {
    url: '/schedule/myCreateScheduleWithDate',
    method: 'post'
  },
  // 获取待庭审排期详情
  mySchedule: {
    url: '/schedule/mySchedule',
    method: 'post'
  },
  // 获取我创建的排期详情
  myCreateSchedule: {
    url: '/schedule/myCreateSchedule',
    method: 'post'
  },
  // 获取按月统计数据
  statisticWithMonth: {
    url: '/client/statisticWithMonth',
    method: 'get'
  },
  // 获取按年统计数据
  statisticWithYear: {
    url: '/client/statisticWithYear',
    method: 'get'
  },
  // 获取庭审统计数据
  statistic: {
    url: '/client/statistic',
    method: 'post'
  }
};
export default withHttp(apis, baseURL);